import {
  HomeOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import {
  Avatar,
  Breadcrumb,
  Button,
  Dropdown,
  Layout,
  MenuProps,
  Space,
  Typography,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { findAdminLink } from '@/components/Admin/adminNav';
import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

const { Header } = Layout;
const { Text } = Typography;

interface AdminHeaderProps {
  collapsed?: boolean;
  isMobile?: boolean;
  onToggle?: () => void;
}

export default function AdminHeader({
  collapsed = false,
  isMobile = false,
  onToggle,
}: AdminHeaderProps) {
  const { logout, profile } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLink = findAdminLink(location.pathname);
  const displayName = profile?.name || '管理員';

  const handleLogout = async () => {
    await logout();
    navigate(Path.Login);
  };

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'front',
      label: '回到前台',
      icon: <HomeOutlined />,
      onClick: () => navigate(Path.Root),
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: '登出',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: handleLogout,
    },
  ];

  const toggleIcon = isMobile ? (
    <MenuOutlined />
  ) : collapsed ? (
    <MenuUnfoldOutlined />
  ) : (
    <MenuFoldOutlined />
  );

  return (
    <Header
      style={{
        padding: isMobile ? '0 16px' : '0 24px',
        height: 64,
        lineHeight: 'normal',
        background: 'var(--admin-surface)',
        borderBottom: '1px solid var(--admin-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 20,
      }}
    >
      <Space size={12} align="center">
        <Button
          type="text"
          aria-label={
            isMobile ? '開啟選單' : collapsed ? '展開側邊欄' : '收合側邊欄'
          }
          icon={toggleIcon}
          onClick={onToggle}
        />
        <Breadcrumb
          items={[
            { title: '後台管理' },
            { title: currentLink?.label ?? '總覽' },
          ]}
        />
      </Space>

      <Dropdown menu={{ items: dropdownItems }} placement="bottomRight" arrow>
        <Space style={{ cursor: 'pointer' }} size={8}>
          <Avatar
            size="small"
            src={profile?.avatarUrl || undefined}
            style={{ backgroundColor: 'var(--ant-color-primary)' }}
          >
            {displayName.charAt(0).toUpperCase()}
          </Avatar>
          {!isMobile && <Text>{displayName}</Text>}
        </Space>
      </Dropdown>
    </Header>
  );
}
